import APITemplate from '@api/APITemplate'
import con from '@services/connection'
import { microsoftIntegration as endpoint } from '@modules/crm/constants/URL'
import { formatQueryParams } from '@utils/Format'

class APICrmMicrosoftIntegration extends APITemplate {
  constructor() {
    super()
    this.MODULE = 'crm'
  }

  async getStatus() {
    const query = formatQueryParams({
      provedor: 'microsoft',
      detailed: true,
    })
    const r = await con.get(endpoint.status + query)
    return (
      r ||
      this.buildErrorResponse({
        message: 'Erro ao verificar status da integração Microsoft.',
      })
    )
  }

  getAuthUrl({ returnTo, scopes } = {}) {
    const isProduction = process.env.NODE_ENV === 'production'
    const baseUrl = isProduction
      ? ''
      : global.BASE_URL || window.location.origin
    return baseUrl + endpoint.auth(returnTo, scopes)
  }

  async revoke() {
    const r = await con.delet(endpoint.revoke)
    return (
      r ||
      this.buildErrorResponse({
        message: 'Erro ao revogar integração Microsoft.',
      })
    )
  }
}

const apiCrmMicrosoftIntegration = new APICrmMicrosoftIntegration()
export { apiCrmMicrosoftIntegration }
